export default __webpack_public_path__ + "static/media/labor_927_1.42cdf320.jpg";